import React, { useState } from 'react';
import { Row } from 'simple-flexbox';
import { createUseStyles, useTheme } from 'react-jss';
import { IconSearch } from '../../../asset/icons';
import UserProfile from '../../../asset/svg/UserProfile.svg'
import { Box, Typography } from '@mui/material';
import downArrow from '../../../asset/svg/downArrow.svg';
import Logout from '@mui/icons-material/Logout';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';

const useStyles = createUseStyles((theme) => ({
    avatar: {
        height: 35,
        width: 35,
        minWidth: 35,
        borderRadius: 50,
        marginLeft: 14,
        border: `1px solid ${theme.color.lightGrayishBlue2}`,
        '@media (max-width: 768px)': {
            marginLeft: 14
        }
    },
    container: {
        height: 40,
        padding: '1.8rem 2rem 1rem 3rem',
        '@media only screen and (max-width: 675px) and (min-width: 300px)': {
            display: 'none'
        }
    },
    image: {
        width: '1.8rem',
        border: '1px solid',
        borderRadius: '100%',
        '@media only screen and (max-width: 675px) and (min-width: 300px)': {
            display: 'none'
        }
    },
    name: {
        color: '#FFFFFF',
        '@media only screen and (max-width: 675px) and (min-width: 300px)': {
            display: 'none'
        }
    },
    downArrowImage: {
        width: '10px',
        '@media only screen and (max-width: 675px) and (min-width: 300px)': {
            display: 'none'
        }
    },
    separator: {
        borderLeft: `1px solid ${theme.color.lightGrayishBlue2}`,
        marginLeft: 32,
        marginRight: 32,
        height: 32,
        width: 2,
        '@media (max-width: 768px)': {
            marginLeft: 14,
            marginRight: 0
        }
    },
    title: {
        ...theme.typography.title,
        '@media (max-width: 1080px)': {
            marginLeft: 50
        },
        '@media (max-width: 468px)': {
            fontSize: 20
        }
    },
    iconStyles: {
        cursor: 'pointer',
        marginLeft: 25,
        '@media (max-width: 768px)': {
            marginLeft: 12
        }
    }
}));

function HeaderComponent({ ...props }) {
    const theme = useTheme();
    const classes = useStyles({ theme });
    const { title } = props
    const FirstName = localStorage.getItem("FirstName");
    const LastName = localStorage.getItem("LastName");
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/';
    }
    return (
        <Row className={classes.container} vertical='center' horizontal='space-between'>
            <span className={classes.title}></span>
            <Row vertical='center'>
                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <img className={classes.image} src={"https://firebasestorage.googleapis.com/v0/b/accrue-d0a3c.appspot.com/o/defaultimages%2Fuser_placeholder.png?alt=media&token=9845e1cb-7374-4a5b-a05c-b8b11285c4f8"} alt="" />&nbsp;&nbsp;&nbsp;
                    <Typography className={classes.name}>{`${FirstName} ${LastName}`}</Typography>
                    <Tooltip title="Account settings">
                        <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <img onClick={handleClick} width='10px' className={classes.downArrowImage} src={downArrow} alt='' />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Menu anchorEl={anchorEl} id="account-menu" open={open} onClose={handleClose} onClick={handleClose}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible', filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))', mt: 1.5,
                            '& .MuiAvatar-root': { width: 32, height: 32, ml: -0.5, mr: 1, },
                            '&:before': { content: '""', display: 'block', position: 'absolute', top: 0, right: 14, width: 10, height: 10, bgcolor: 'background.paper', transform: 'translateY(-50%) rotate(45deg)', zIndex: 0, },
                        },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem onClick={handleLogout}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                    </MenuItem>
                </Menu>
            </Row>
        </Row>
    );
}

export default HeaderComponent;
